export default [
  {
    path: '/apps/campos-customizado/list',
    name: 'apps-campos-customizado-list',
    component: () => import('@/views/app/campos-personalizado/list/Index.vue'),
    meta: {
      pageTitle: 'Campos Customizados',
    },
  },
];
